<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }} 
                        <template v-if="isEdit">
                            {{ $t('reportsparam.for') }}
                            <span class="page_title_value">
                                {{ this.parentObject.pageTitleValue }}
                            </span>
                        </template>
                    </h2>
                </v-row>
        
                <v-container id="scroll-target" class="custom-form overflow-y-auto px-5">
                    <v-row>
                      <v-col cols="4" sm="6" class="pb-n5">
                       <v-text-field
                                outlined
                                :label="this.$t('Setuprankmapset.rankmapset')"
                                type="text"
                                ref="rankmapset"
                                :rules="[rules.required]"
                                v-model="formData.rankmapset"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="4" sm="6" class="pb-n4 mt-n8">
                       <v-text-field
                                outlined
                                :label="this.$t('Setuprankmapset.rankmapsetdescription')"
                                type="text"
                                ref="description"
                                :rules="[rules.required]"
                                v-model="formData.description"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="4" sm="6" class="pb-n4 mt-n8">
                       <v-text-field
                                outlined
                                :label="this.$t('columns.remark')"
                                type="text"
                                ref="remark"
                                v-model="formData.remark"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-checkbox
                                outlined
                                ref="disable"
                                v-model="formData.disable"
                                :label="this.$t('columns.disable')"
                                @change="updateValue"
                                dense
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-checkbox
                                outlined
                                ref="weightedavg"
                                v-model="formData.weightedavg"
                                :label="$t('pmrankmapset.weightedaverage')"
                                @change="updateValue"
                                dense
                            ></v-checkbox>
                        </v-col>
                    </v-row>

                    <v-row class="mt-4">
                        <v-col style="margin-left: -120px;"> <!-- Adjust this value as needed -->
                            <app-formbuttons 
                                v-on:SavePressed="saveHandler" 
                                v-on:DeletePressed="deleteHandler"
                                v-on:CancelPressed="cancelHandler"
                            />
                        </v-col>
                    </v-row>

                    <v-row v-if="isEdit">
                        <v-col cols="6" sm="6" class="blue--text">
                            {{$t('Setuprankmapset.rankmapping')}}
                        </v-col>
                    </v-row>

                    <v-row v-if="isEdit">
                        <app-table
                            v-bind:parentObject="{
                                tabHeader: this.tabHeader,
                                detailItem: this.parentObject.rankmapSetDetailsList,
                                pmrankmapsetid: this.parentObject.data.id
                            }"
                            v-on:input="addItemHandler"
                        />
                    </v-row>

                </v-container>

                
            </v-form>
        </v-container>
    </div>
</template>

<script>
import CRUDTable from './CRUDTable';

export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-table': CRUDTable,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            },
            formData: {
                rankmapset: this.parentObject.data.rankmapset,
                description: this.parentObject.data.description,
                disable: this.parentObject.data.disable,
                weightedavg: this.parentObject.data.weightedavg,
                remark: this.parentObject.data.remark,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid
            },
      
            errMsg: '',
            isErr: false,
            isEdit : this.parentObject.isEdit,

              tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('Setuprankmapset.uptoscore'), value: 'uptoscore', width: '200px', sortable: true},
                { text: this.$t('Setuprankmapset.rank'), value: 'rank', width: '200px', sortable: true},
                //{ text: this.$t('Setuprankmapset.isLast'), value: 'isLastText', width: '200px', sortable: true},
                { text: this.$t('Setuprankmapset.isMedian'), value: 'isMedianText', width: '200px', sortable: true},
                //{ text: this.$t('Setuprankmapset.distribution'), value: 'distribution', width: '200px', sortable: true},
                { text: this.$t('pmassementrecord.distribution'), value: 'distribution', width: '200px', sortable: true},
            ],
        }
    },

    methods: {

        addItemHandler($event) {
            this.formData.rankmapsetdetail=$event
            
            this.updateValue();
        },


        updateValue() {
            this.$emit('input', {
                rankmapset: this.formData.rankmapset,
                description: this.formData.description,
                disable: this.formData.disable,
                weightedavg: this.formData.weightedavg,
                remark: this.formData.remark,
                rankmapsetdetail: this.formData.rankmapsetdetail,
                stamp: this.formData.stamp,
                userid: this.formData.userid
            });
        },

        newHandler() {
            this.$emit('new');
        },

        saveHandler() {
            this.$emit('save');
        },

        deleteHandler() {
            this.$emit('delete');
        },

        cancelHandler() {
            this.$router.push({name: 'rankmapsetlist'});
        },
    },

    mounted() {

    }
    
}
</script>